export const checkListList = {
  childHeader: 'Tool Preventive Maintenance PLAN STATUS',
  addButtonLable: '',
  datePickerLabel: 'Search By Year',
  modalTile: 'UPDATE STATUS',
};

export const apiConstant = {
  getAllStatus: 'toolPreventiveMaintenancePlanNewStatusRoute/getAllSatusByYear',
  upadateListStatus:
    'toolPreventiveMaintenancePlanNewStatusRoute/handleStatusUpdate',
  checklistUpload: 'toolPreventiveMaintenancePlanNewStatusRoute/handleUpload',
  checklistDeleteImage:
    'toolPreventiveMaintenancePlanNewStatusRoute/handleDeleteImage',
  machineDataForAutoComplete: '',
};

export const navigationConstant = {
  checklistRouter: '/common/toolPreventiveMaintenancePlanNewStatusCheckList',
};
